export default __webpack_public_path__ + "static/media/spigot.ce7aeb83.svg";